(function(){
  document.querySelectorAll('[data-pt-offer]').forEach(function(f){
    var out=f.querySelector('[data-pt-price]');
    function upd(){var c=f.querySelector('input[name="id"]:checked');if(c&&out){out.textContent=c.getAttribute('data-price');}}
    f.addEventListener('change',upd);upd();
  });
  document.querySelectorAll('[data-pt-gal]').forEach(function(g){
    var main=g.querySelector('[data-pt-main]');
    g.querySelectorAll('[data-pt-thumb]').forEach(function(b){
      b.addEventListener('click',function(){
        if(main){main.src=b.getAttribute('data-src');}
        g.querySelectorAll('[data-pt-thumb]').forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active');
      });
    });
  });
  var rv=document.querySelectorAll('.pt-rv');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    rv.forEach(function(el){io.observe(el);});
  } else { rv.forEach(function(el){el.classList.add('is-in');}); }
  document.querySelectorAll('[data-pt-bar]').forEach(function(b){setTimeout(function(){b.style.width=b.getAttribute('data-pt-bar');},400);});
  var s=document.querySelector('[data-pt-sticky]');
  if(s){
    var t=document.querySelector('[data-pt-hide-sticky]');
    var onScroll=function(){
      var past=window.scrollY>560,vis=false;
      if(t){var r=t.getBoundingClientRect();vis=r.top<window.innerHeight&&r.bottom>0;}
      s.classList.toggle('is-on',past&&!vis);
    };
    window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  }
})();
